import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomContentDirective } from './directives/custom-content.directive';
import { DialogComponent } from './dialog.component';
import { FricLowMaterialModule } from 'src/app/material';
import { DialogService } from './services/dialog.service';

@NgModule({
  declarations: [CustomContentDirective, DialogComponent],
  imports: [
    CommonModule,
    FricLowMaterialModule,
  ],
  exports: [DialogComponent],
  providers: [DialogService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class DialogModule {}
